/*
 * Shared MCQ bank + prompt builder for the inline MCQ quiz card.
 * Hardcoded for now (like dsaProblem.js); swap for a backend/LLM generator
 * later — the McqCard UI stays the same.
 */
export const MCQ_TOPIC = 'Data Structures';
export const MCQ_DIFFICULTY = 'Medium';

export const MCQS = [
  {
    question: 'What is the time complexity of a search operation in a balanced Binary Search Tree?',
    options: ['O(1)', 'O(log n)', 'O(n)', 'O(n log n)'],
    correct: 1,
    explanation: 'A balanced BST halves the search space at each step, so search is O(log n).',
  },
  {
    question: 'Which data structure follows the LIFO (Last In, First Out) principle?',
    options: ['Queue', 'Stack', 'Linked List', 'Heap'],
    correct: 1,
    explanation: 'A stack pushes and pops from the same end, so the last element in is the first out.',
  },
  {
    question: 'What is the worst-case time complexity of Quick Sort?',
    options: ['O(n)', 'O(n log n)', 'O(n²)', 'O(log n)'],
    correct: 2,
    explanation: 'With a poor pivot (e.g. already-sorted input), partitions are maximally unbalanced → O(n²).',
  },
  {
    question: 'Which tree traversal visits the root node between its left and right subtrees?',
    options: ['Pre-order', 'In-order', 'Post-order', 'Level-order'],
    correct: 1,
    explanation: 'In-order traversal is Left → Root → Right, which yields sorted order for a BST.',
  },
  {
    question: 'What is the average-case time complexity of a lookup in a hash table?',
    options: ['O(1)', 'O(log n)', 'O(n)', 'O(n²)'],
    correct: 0,
    explanation: 'With a good hash function and load factor, lookups are O(1) on average.',
  },
  {
    question: 'Which of these is NOT a linear data structure?',
    options: ['Array', 'Stack', 'Queue', 'Tree'],
    correct: 3,
    explanation: 'A tree is hierarchical (non-linear); the others store elements sequentially.',
  },
  {
    question: 'Which data structure is most suitable for implementing a priority queue?',
    options: ['Array', 'Heap', 'Stack', 'Hash Table'],
    correct: 1,
    explanation: 'A binary heap gives O(log n) insert and extract-min/max, ideal for a priority queue.',
  },
  {
    question: 'What is the time complexity to insert a node at the head of a singly linked list?',
    options: ['O(1)', 'O(log n)', 'O(n)', 'O(n log n)'],
    correct: 0,
    explanation: 'Inserting at the head only re-points the head pointer — constant time.',
  },
  {
    question: 'Which algorithm finds shortest paths from a single source with non-negative edge weights?',
    options: ['Kruskal’s', 'Dijkstra’s', 'Bellman-Ford', 'Floyd-Warshall'],
    correct: 1,
    explanation: 'Dijkstra’s algorithm is the standard single-source shortest-path algorithm for non-negative weights.',
  },
  {
    question: 'What is the space complexity of the standard merge sort?',
    options: ['O(1)', 'O(log n)', 'O(n)', 'O(n²)'],
    correct: 2,
    explanation: 'Merge sort needs an auxiliary array of size n for merging, so O(n) extra space.',
  },
];

const letter = (i) => String.fromCharCode(65 + i);

/* Wrap an assistant instruction with the current question as context. */
export function buildMcqPrompt(q, userPrompt) {
  const opts = q.options.map((o, i) => `${letter(i)}) ${o}`).join('\n');
  return `You are DataVerse.ai, a multiple-choice quiz tutor. The current question is:
"${q.question}"
${opts}
(The correct option is ${letter(q.correct)}.)

${userPrompt}
Answer concisely in markdown.`;
}
